import * as React from "react";
import { useEffect, useState } from "react";
import Csrf from "../commons/model/Csrf";
import CsrfInput from "./CsrfInput";
import { DatePicker } from "react-date-picker";
import useGetLocale from "../commons/hooks/useGetLocale";

interface LoginProps {
  errorMessages: string[];
  csrf: Csrf;
  loginDateError?: boolean;
  loginNameError?: boolean;
}

export default function Login({ errorMessages, csrf, loginDateError, loginNameError }: LoginProps) {
  const [showErrorPanel, setShowErrorPanel] = useState(false);
  const [showBirthdateErrorLabel, setShowBirthdateErrorLabel] = useState(loginDateError ?? false);
  const [showNameErrorLabel, setShowNameErrorLabel] = useState(loginNameError ?? false);
  const [dateOfBirth, setDateOfBirth] = useState(null);

  useEffect(() => {
    setShowErrorPanel(errorMessages.length > 0);
    setShowNameErrorLabel(loginNameError ?? false);
    setShowBirthdateErrorLabel(loginDateError ?? false);
  }, []);

  const errorPanel = (
    <div className="alert-error">
      {errorMessages.map((message) => (
        <li key={message}>{i18n[message]}</li>
      ))}
    </div>
  );

  const nameErrorLabel = (
    <div className={"input-group" + (showNameErrorLabel ? " invalid" : "")}>
      <div className="error-message" id="error-for-name">
        {i18n["Page.PublicLogin.Error.MissingName"]}
      </div>
    </div>
  );

  const birthdateErrorLabel = (
    <div className={"input-group" + (showBirthdateErrorLabel ? " invalid" : "")}>
      <div className="error-message" id="error-for-birthdate">
        {i18n["Page.PublicLogin.Error.MissingBirthdate"]}
      </div>
    </div>
  );

  return (
    <form method="post"
          className="react-form"
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault(); // DatePicker already register the event and we want to take the ownership
              const form = e.currentTarget;
              form.requestSubmit();
            }
          }}
    >
      <CsrfInput csrf={csrf} />
      <div className="title-bar">
        <h1 className="title">{i18n["Page.PublicLogin.Title"]}</h1>
      </div>
      {showErrorPanel && errorPanel}
      <div>
        <p>{i18n["Page.PublicLogin.Description"]}</p>
      </div>
      <div className={"input-group"}>
        <div className={"input-group"}>
          <div className="group">
            <label htmlFor="name">{i18n["Page.PublicLogin.Name.Label"]}</label>
            <input
              id="name"
              name="name"
              type="text"
              placeholder={i18n["Page.PublicLogin.Name.PlaceHolder"]}
              maxLength={3}
            />
            {showNameErrorLabel && nameErrorLabel}
          </div>
        </div>

        <div className={"input-group"}>
          <div className="group">
            <label htmlFor="date">
              <span>{i18n["Page.PublicLogin.Birthdate"]}</span>
            </label>
            <DatePicker
              name={"date"}
              onChange={(date) => updateDateOfBirth(date)}
              value={dateOfBirth}
              dayPlaceholder={i18n["DatePicker.Day.Placeholder"]}
              monthPlaceholder={i18n["DatePicker.Month.Placeholder"]}
              yearPlaceholder={i18n["DatePicker.Year.Placeholder"]}
              className={"date-calendar"}
              locale={useGetLocale()}
              maxDate={new Date()}
              minDate={new Date(1900, 0, 1)}
              calendarIcon={null}
              clearIcon={null}
              openCalendarOnFocus={false}
              disabled={false}
            />
            {showBirthdateErrorLabel && birthdateErrorLabel}
          </div>
        </div>
      </div>
      <div className="action-container">
        <input type="submit" className="button-primary" value={i18n["Page.PublicLogin.Submit"]} />
      </div>
    </form>
  );

  function updateDateOfBirth(date) {
    if (date == null || date instanceof Date) {
      setDateOfBirth(date);
    }
  }
}
